var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsVersion',{attrs:{"label":"每日點檢表公版版本列表","localeMode":true,"id":_vm.$route.params.id,"modelName":_vm.modelName,"versionModelName":_vm.versionModelName,"fields":_vm.versionFields,"showFields":_vm.showFields}})}
var staticRenderFns = []

export { render, staticRenderFns }